import { FuncionarioBasico } from './funcionario-basico.model';
import { UnidadeBM } from './unidadebm.model';

export interface MovimentoAndamento {
  CODMOVIMENTOANDAMENTO?: number;
  CODANDAMENTO?: number;
  RESPONSAVELMOVIMENTO?: FuncionarioBasico; // Remetente do movimento. Null para movimentos antigos e envio de solicitações externas.
  RESPONSAVELDESTINO: FuncionarioBasico;
  RESPONSAVELRECEBIMENTO?: FuncionarioBasico;
  CADASTRO?: string;
  ORIGEM?: UnidadeBM;
  DESTINO: UnidadeBM;
  PRIORIDADE: {
    CODPRIORIDADE: number; // 1 - Baixa, 2 - Média, 3 - Alta
    TITULO?: string;
  };
  SITUACAO?: {
    CODSITUACAO: number; // 1 - Aguardando, 2 - Recebido, 3 - Recusado
    TITULO: string;
    DATA: string; // Data de Recebimento, Recusa ou Suspensão
  };
  ATUALIZACAO?: string; // Data da última atualização do movimento, incluindo criação e exclusão
}

export const LISTA_PRIORIDADES_MOVIMENTO_ANDAMENTO = [
  { CODPRIORIDADE: 1, TITULO: 'BAIXA' },
  { CODPRIORIDADE: 2, TITULO: 'MÉDIA' },
  { CODPRIORIDADE: 3, TITULO: 'ALTA' },
];

export enum EnumSituacaoMovimentoAndamento {
  AGUARDANDO = 1,
  RECEBIDO = 2,
  RECUSADO = 3,
  SUSPENSO = 4,
}
